export default __webpack_public_path__ + "static/media/expandChart.c87bd92e.svg";